import '@/services/apiConfig'
import { abilitiesPlugin } from '@casl/vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import App from './App.vue'
import workbox from './registerServiceWorker'
import router from './router'
import ability from './services/ability'

import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primevue/resources/primevue.min.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import './assets/bis.css'
import './assets/styles.css'

import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import AutoComplete from 'primevue/autocomplete'
import BadgeDirective from 'primevue/badgedirective'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import Card from 'primevue/card'
import Chart from 'primevue/chart'
import Checkbox from 'primevue/checkbox'
import Chips from 'primevue/chips'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import FileUpload from 'primevue/fileupload'
import Image from 'primevue/image'
import InputMask from 'primevue/inputmask'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import Listbox from 'primevue/listbox'
import Menu from 'primevue/menu'
import Message from 'primevue/message'
import MultiSelect from 'primevue/multiselect'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressBar from 'primevue/progressbar'
import RadioButton from 'primevue/radiobutton'
import SelectButton from 'primevue/selectbutton'
import Skeleton from 'primevue/skeleton'
import SplitButton from 'primevue/splitbutton'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import Tag from 'primevue/tag'
import Textarea from 'primevue/textarea'
import Timeline from 'primevue/timeline'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Toolbar from 'primevue/toolbar'
import Tooltip from 'primevue/tooltip'
import JsonExcel from 'vue-json-excel3'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(PrimeVue)
app.use(ToastService)
app.use(abilitiesPlugin, ability)
app.provide('workbox', workbox)
app.provide('ability', ability)

app.component('AutoComplete', AutoComplete)
app.component('Accordion', Accordion)
app.component('AccordionTab', AccordionTab)
app.component('Calendar', Calendar)
app.component('Card', Card)
app.component('Chips', Chips)
app.component('Checkbox', Checkbox)
app.component('Column', Column)
app.component('Button', Button)
app.component('DataTable', DataTable)
app.component('Dialog', Dialog)
app.component('Divider', Divider)
app.component('Dropdown', Dropdown)
app.component('Image', Image)
app.component('InputMask', InputMask)
app.component('InputNumber', InputNumber)
app.component('InputText', InputText)
app.component('InputSwitch', InputSwitch)
app.component('Listbox', Listbox)
app.component('Menu', Menu)
app.component('Message', Message)
app.component('MultiSelect', MultiSelect)
app.component('OverlayPanel', OverlayPanel)
app.component('RadioButton', RadioButton)
app.component('SelectButton', SelectButton)
app.component('Skeleton', Skeleton)
app.component('SplitButton', SplitButton)
app.component('Tag', Tag)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('Textarea', Textarea)
app.component('Toast', Toast)
app.component('Toolbar', Toolbar)
app.component('FileUpload', FileUpload)
app.component('Timeline', Timeline)
app.component('downloadExcel', JsonExcel)
app.component('Chart', Chart)
app.component('ProgressBar', ProgressBar)

app.directive('tooltip', Tooltip)
app.directive('badge', BadgeDirective)

app.mount('#app')
